import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  status: {
    marginRight: 54.1,
    marginBottom: 10,
    width: 114,
    height: 12.5,
  },
  statusValue: {
    marginRight: 54.1,
    width: 114,

    height: 12.5,
  },
  paymentMethod: {
    marginRight: 54.1,
    marginBottom: 10,
    width: 114,

    height: 12.5,
  },
  card: {
    width: 114,
    height: 12.5,
  },
  billCode: {
    marginBottom: 10,
    marginRight: 54.1,
    width: 114,

    height: 12.5,
  },
  billCodeValue: {
    marginBottom: 27.1,
    marginRight: 54.1,
    width: 114,

    height: 12.5,
  },
  billText: {
    marginBottom: 10,
    width: 114,
    height: 12.5,
  },
  billValue: {
    marginBottom: 27.1,
    width: 114,
    height: 12.5,
  },
  paymentButton: {
    marginBottom: 16.7,
    width: '100%',
    height: 42,
  },
  downloadButton: {
    marginBottom: 7,
    width: '100%',
    height: 42,
  },
  line: {
    marginBottom: 19,
    marginTop: 19,
    width: '100%',
    height: 1,
  },
  buttonLoading: {
    marginVertical: 5,
    marginHorizontal: "25%"
  }
});
